<template>
  <v-container fluid>
    <v-layout row wrap align-content-center>
      <!-- DATES PICKER -->
      <v-flex xs12 sm12 md12 lg12>
        <v-layout row wrap justify-center>
          <!-- <v-flex xs12 sm6 md6 lg6 class="px-1">
            <v-card class="search-box">
              <v-card-title primary-title class="headline desc-box">{{ $t("book.istr_title") }}</v-card-title>
              <v-card-text class="subheading mt-1">
                <p class="mt-4">
                  <v-icon color="info">fas fa-search</v-icon>
                  &nbsp;&nbsp;{{ $t("book.step1") }}
                </p>
                <p class="mt-4">
                  <v-icon color="red">fas fa-heart</v-icon>
                  &nbsp;&nbsp;{{ $t("book.step2") }}
                </p>
                <p class="mt-4">
                  <v-icon color="blue-grey">fas fa-envelope</v-icon>
                  &nbsp;&nbsp;{{ $t("book.step3") }}
                </p>
              </v-card-text>
            </v-card>
          </v-flex> -->
          <v-flex xs12 sm6 md6 lg6 class="px-1">
            <!-- <div class="search-box">
              <date-picker
                @search-booking="searchBooking($event)"
                :loading="loading"
                :confirm="confirm"
                @open-dialog="bookingDialog = true"
              ></date-picker>
            </div> -->
            <v-card style="max-height: 400px;">
              <v-card-title primary-title>
                <v-img
                  class="white--text"
                  height="150px"
                  :src="getImageUrl('oblo/reception 2.jpeg')"
                >
                  <v-container fill-height fluid>
                    <v-layout fill-height>
                      <v-flex xs12 align-end flexbox>
                        <span class="headline" style="text-shadow: rgb(29, 29, 29) 2px 2px;">{{$t("book.istr_title")}}</span>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-img>
              </v-card-title>

              <v-card-text>
                <v-layout row wrap>
					<iframe src="https://www.bed-and-breakfast.it/scripts/widget-richieste/widget_iframe.cfm?idbooking=27395&l=en&colore=ir_grigio_scuro_piatto&wl=1" 
						scrolling="no" 
						frameborder="0" 
						style="border: none; overflow: hidden; margin-top: 20px; width: 100%; height: 420px;" 
						allowtransparency="true" 
					/>
				</v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>

      <!-- RESULTS -->
      <v-flex xs12 sm12 md12 lg12 class="mt-3">
        <!-- More than 2 results -->
        <v-layout row wrap v-if="results.length >= 2">
          <v-flex
            xs12
            sm6
            md6
            lg6
            v-for="(room, index) in results"
            :key="index"
          >
            <book-result
              :room="room"
              class="mb-3"
              @like-ev="roomLiked($event)"
            ></book-result>
          </v-flex>
        </v-layout>
        <!-- Just 1 result -->
        <v-layout row wrap v-else>
          <v-flex
            class="px-5"
            xs12
            sm12
            md12
            lg12
            v-for="(room, index) in results"
            :key="index"
          >
            <book-result
              :room="room"
              class="mb-3"
              @like-ev="roomLiked($event)"
              :key="index"
            ></book-result>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-layout row v-if="results.length == 0">
      <v-flex xs12 class="px-1">
        <v-alert :value="noRooms" type="warning" class="subheading white--text">
          {{ $t("book.no_rooms") }}
        </v-alert>
      </v-flex>
    </v-layout>

    <booking-dialog
      v-model="bookingDialog"
      :rooms="roomsToBook"
      @close="bookingDialog = false"
      @try-booking="tryToBooking($event)"
    ></booking-dialog>
  </v-container>
</template>

<script>
import DatePicker from "./modules/DatePicker";
import BookResult from "./modules/BookResult";
import BookingDialog from "./modules/BookingDialog";
import Room from "../../models/room";

export default {
  name: "Booking",
  components: { DatePicker, BookResult, BookingDialog },
  data() {
    return {
      loading: false,
      results: [],
      confirm: false,
      bookingDialog: false,
      roomsToBook: [],
      searchingParameters: undefined,
      noRooms: false,
    };
  },
  mounted() {
    this.initRooms();
  },
  methods: {
    initRooms() {
      // Get rooms config
      let tmp = require("../../config/rooms.json");
      let rooms = [];

      // Rooms population
      for (let room of tmp) {
        let r = new Room(room.name);
        r = { ...r, ...room };

        rooms.push(r);
      }

      this.$store.dispatch("db/setRooms", rooms);
    },
    searchBooking($event) {
      this.loading = true;
      this.searchingParameters = $event;

      // Reset previous results
      this.results = [];

      // Check dates errors
      if (!this.datesCoerence($event)) {
        this.$awn.warning(this.$t("book.datesCoerence"));
        this.loading = false;
        return;
      }

      this.$store
        .dispatch("db/searchRooms", { in: $event.dateIn, out: $event.dateOut })
        .then((res) => {
          /**** IS A TEST ****/
          // res = require("./fake.json")
          /*******************/

          this.loading = false;

          if (res.books.length == 0) {
            // All rooms free!
            this.results = this.$store.getters["db/getRooms"].slice(0);
          } else {
            // Some rooms booked
            // Look inside...
            for (let reservation of res.books) {
              // Exclude records with all rooms booked
              if (reservation.rooms.length < 4) {
                // Concat results
                this.results = this.results.concat(reservation.rooms);
              }
            }

            // If possible rooms are available
            if (this.results.length > 0) {
              // Remove duplicated items
              this.results = [...new Set(this.results)];
              // Find rooms available from the entire results concatenation
              this.results = this.findRoomFree(this.results);
            } else this.noRooms = !this.noRooms;
            //   this.$awn.warning(this.$t('book.no_rooms'));
          }

          // All rooms busy!
          if (this.results.length == 0) this.noRooms = !this.noRooms;
          //   this.$awn.warning(this.$t('book.no_rooms'));

          // If we have results, enable confirm btn
          // if (this.results.length > 0) this.confirm = true;

          /* Response sample (the room named first is busy...the others? FREE)
                        {
                        "books": [
                                {
                                    "dateIn": "2019-03-25",
                                    "dateOut": "2019-03-27",
                                    "rooms": "["first", "third"]"
                                }
                            ]
                        }
                     ...or empty; this is the perfect case means that all rooms 
                     are available to be booked
                    {
                        "books":[]
                    }
                    */
        })
        .catch((err) => {
          console.log(err);

          this.loading = false;
          this.$awn.alert(err.message);
        });
    },
    datesCoerence(book) {
      let res = true;

      // Check dateIn with current time
      if (
        new Date(book.dateIn) < new Date(new Date().toISOString().substr(0, 10))
      )
        res = false;
      // Check dateOut with dateIn time
      if (new Date(book.dateOut) < new Date(book.dateIn)) res = false;

      return res;
    },
    findRoomFree(rooms) {
      let res = [];

      if (rooms.indexOf("nostromo") == -1)
        res.push(this.$store.getters["db/getRoomByName"]("nostromo"));
      if (rooms.indexOf("mozzo") == -1)
        res.push(this.$store.getters["db/getRoomByName"]("mozzo"));
      if (rooms.indexOf("ammiraglio") == -1)
        res.push(this.$store.getters["db/getRoomByName"]("ammiraglio"));
      if (rooms.indexOf("capitano") == -1)
        res.push(this.$store.getters["db/getRoomByName"]("capitano"));

      return res;
    },
    checkLastBookingTentantive() {
      let result = true;
      let tmp = localStorage.getItem("lastBook");

      if (tmp) {
        let hours = Math.abs(new Date().getTime() - tmp) / 36e5;

        // From a book and the next one
        // 24h must be pass
        if (hours < 24) {
          result = false;
          this.$awn.warning(this.$t("book.booking_controller"));
        }
      }

      return result;
    },
    tryToBooking($event) {
      this.bookingDialog = false;

      if (!this.checkLastBookingTentantive()) return;

      // ToDo: Move to a mixin
      function genUUID() {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
          /[xy]/g,
          function (c) {
            var r = (Math.random() * 16) | 0,
              v = c == "x" ? r : (r & 0x3) | 0x8;
            return v.toString(16);
          }
        );
      }

      // Assemble full booking request object
      let bookingRequest = {
        ...$event,
        ...this.searchingParameters,
        ...{
          rooms: this.$store.getters["db/getRooms"].filter((r) => r.favorite),
        }, // to retrieve favorites
      };
      bookingRequest.id = genUUID();

      // From rooms retrieve only names
      let tmp = [];
      for (let r of bookingRequest.rooms) tmp.push(r.name);

      bookingRequest.rooms = tmp;

      // Dispatch to Dynamodb
      this.$store
        .dispatch("db/storeBooking", bookingRequest)
        .then((res) => {
          this.$awn.info(this.$t("book.dialog.feedback2"));
          this.$awn.success(this.$t("book.dialog.feedback1"));

          // Localstorage last timestamp
          localStorage.setItem("lastBook", new Date().getTime());
        })
        .catch((err) => {
          console.log(err);

          this.$awn.alert(err.message);
        });
    },
    async roomLiked($event) {
      await this.$store.dispatch("db/updateRoom", $event);
      this.roomsToBook = this.$store.getters["db/getRooms"].filter(
        (r) => r.favorite
      );

      if (this.roomsToBook.length > 0) this.confirm = true;
      else this.confirm = false;
    },

	getImageUrl: function(image){
    	return require(`../../assets/img/${image}`);
    }
  },
};
</script>

<style scoped>
.search-box {
  min-height: 428px;
}

.desc-box {
  color: white;
  background-color: var(--v-success-base);
}
</style>